"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var API_URL = 'v1/policies';
exports.getPoliciesUsingGET = function (params) {
    return {
        url: API_URL + "?" + params.toString(),
        method: 'GET',
    };
};
exports.getUnderlyingPoliciesUsingGet = function (masterPolicyNo, params) {
    return {
        url: API_URL + "/" + masterPolicyNo + "/underlyingPolicies?" + params.toString(),
        method: 'GET',
    };
};
exports.getUnderlyingPoliciesByPartyUsingGet = function (partyId, policyStatus, params) {
    if (!params) {
        params = new URLSearchParams();
    }
    params.append('partyId', partyId.toString());
    params.append('policyStatus', policyStatus);
    return {
        url: API_URL + "/underlyingPoliciesByParty?" + params.toString(),
        method: 'GET',
    };
};
